import { MemberRoleType } from 'features/signup';
import { AdminManagerType, AdminManagersInputType } from 'shared/model';

import request from './core';

export type PostListingRequest = {
  adminId?: number;
  imageUrls: string[];
  roomType: 'STUDIO' | 'SHAREHOUSE' | 'OFFICETEL' | 'OTHERS';
  area: number;
  agentCommentTypes: Array<
    | 'COMMENT1'
    | 'COMMENT2'
    | 'COMMENT3'
    | 'COMMENT4'
    | 'COMMENT5'
    | 'COMMENT6'
    | 'COMMENT7'
    | 'COMMENT8'
    | 'COMMENT9'
    | 'COMMENT10'
    | 'COMMENT11'
  >;
  agentCommentDetailKr?: string;
  address: string;
  addressDetail?: string;
  addressEN: string;
  latitude: number;
  longitude: number;
  nearSubwayStationInfos: {
    subwayStation: string;
    duration: number;
  }[];
  nearUniversityTypes: Array<
    | 'SNU'
    | 'SSU'
    | 'CAU'
    | 'SKKU'
    | 'KOREA'
    | 'DONGGUK'
    | 'EWHA'
    | 'KHU'
    | 'HUFS'
    | 'KONKUK'
    | 'HONGIK'
    | 'YONSEI'
    | 'SOGANG'
    | 'UOS'
    | 'HANSUNG'
    | 'SEJONG'
    | 'SUNGSHIN_WOMEN'
    | 'CATHOLIC_KOREA'
    | 'METHODIST_THEOLOGICAL'
    | 'KYONGGI'
    | 'KWANGWOON'
    | 'KOOKMIN'
    | 'KOREA_CHRISTIAN'
    | 'DUKSUNG_WOMEN'
    | 'DONGDUK_WOMEN'
    | 'MYONGJI'
    | 'SAHMYOOK'
    | 'SANGMYUNG'
    | 'SEOKYEONG'
    | 'SEOUL_HANYOUNG'
    | 'SEOULTECH'
    | 'SEOUL_NATIONAL_EDUCATION'
    | 'SEOUL_CHRISTIAN'
    | 'SEOUL_WOMEN'
    | 'SUNGKONGHOE'
    | 'SOOKMYUNG_WOMEN'
    | 'PRESBYTERIAN_THEOLOGICAL'
    | 'CHONGSHIN'
    | 'CHUGYE_ARTS'
    | 'KAIST_SEOUL'
    | 'KOREAN_BIBLE'
    | 'KOREA_NATIONAL_ARTS'
    | 'KOREA_NATIONAL_SPORT'
    | 'HANSHIN'
    | 'HANYANG'
    | 'DONGYANG_MIRAE'
    | 'MYONGJI_COLLEGE'
    | 'BAEWHA_WOMEN'
    | 'SAHMYOOK_HEALTH'
    | 'SEOUL_WOMEN_NURSING'
    | 'SEOIL'
    | 'SOONGEUI_WOMEN'
    | 'INDUK'
    | 'HANYANG_WOMEN'
    | 'GACHON'
    | 'HANYANG_ERICA'
    | 'INHA'
    | 'AJOU'
    | 'KHU_GLOBAL'
    | 'SKKU_SUWON'
    | 'HUFS_GLOBAL'
    | 'CAU_ANSEONG'
    | 'CATHOLIC_KOREA_BUCHEON'
    | 'MYONGJI_YONGIN'
    | 'ANSAN'
    | 'BUCHEON'
    | 'SNU_YEONGEON'
    | 'KAIST_DAEJEON'
    | 'CNU'
    | 'HANBAT'
    | 'WOOSONG'
    | 'PAI_CHAI'
    | 'MOKWON'
    | 'DAEJEON'
    | 'EULJI_DAEJEON'
  >;
  roomFloor: number | null;
  totalFloor: number;
  isSemiBasement: boolean;
  isRooftop: boolean;
  facilityTypes: Array<'ELEVATOR' | 'CCTV' | 'ENTRY_DOORLOCK'>;
  heatingType: 'INDIVIDUAL' | 'CENTRAL';
  windowDirectionType:
    | 'NORTH'
    | 'NORTHEAST'
    | 'EAST'
    | 'SOUTHEAST'
    | 'SOUTH'
    | 'SOUTHWEST'
    | 'WEST'
    | 'NORTHWEST'
    | 'UNABLE';
  buildingFrontType: 'EXIST' | 'NOT_EXIST' | 'UNKNOWN';
  basicFurnitureTypes: Array<
    | 'GAS_STOVE'
    | 'INDUCTION'
    | 'REFRIGERATOR'
    | 'WASHING_MACHINE'
    | 'MICROWAVE_OVEN'
    | 'AIR_CONDITIONING'
    | 'DRYER'
    | 'TABLE'
    | 'TV'
    | 'WIFI'
    | 'WARDROBE'
    | 'SHELF'
    | 'DRAWER'
    | 'SHOE_RACK'
    | 'BED'
  >;
  deposit: number;
  monthlyRent: number;
  provisionalDeposit?: number;
  agencyFee: number;
  paymentType: 'MONTHLY' | 'LUMP_SUM';
  maintenanceFee: number;
  maintenanceFeeBreakdownKr?: string;
  rentExcludesTypes: Array<'ELECTRICITY' | 'WATER' | 'GAS' | 'INTERNET'>;
  /** 즉시 입주 가능(isImmediateMoveIn=true)이면 생략. 서버가 오늘 날짜로 폴백 저장. */
  moveInDate?: string;
  isImmediateMoveIn: boolean;
  minContractPeriod: number;
  adminManagerIds: number[];

  buildingUseApprovalDate: string;
  isIllegalConstruction: boolean;
  buildingRegisteredUseTypes: Array<
    | 'DETACHED_HOUSES'
    | 'MULTI_FAMILY_HOUSING'
    | 'CLASS_ONE_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'CLASS_TWO_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'OFFICETEL'
    | 'LODGING_FACILITIES'
    | 'EDUCATIONAL_AND_RESEARCH_FACILITIES'
  >;

  hasParkingLot: boolean;
  parkingLotCount?: number;

  bathroomCount: number;

  rentalType: 'MONTHLY_RENT' | 'SEMI_JEONSE' | 'JEONSE';
  isGuaranteesListing: boolean;

  hasNoAddressDetail: boolean;
};

export type getListingRequest = {
  agencyName: string | undefined;
  listingSearchType: 'NEAR_SUBWAY_STATION' | 'ADDRESS' | 'KEYWORD' | 'MIN_CONTRACT_PERIOD' | 'LISTING_ID' | undefined;
  searchValue: string | undefined;
  visibleType: 'ALL' | 'VISIBLE';

  /** 가계약 상태 필터 (미지정 시 전체) */
  provisionalContractStatus?: 'NONE' | 'REQUEST_RECEIVED' | 'COMPLETED';

  /** 매물번호 */
  listingId?: number;
  /** 최소 계약기간 */
  minContractPeriod?: number;

  /**
   * 입주가능일 "업데이트 필요" 매물을 전체 데이터셋에서 상단으로 모으는 정렬(경과 오래된 순).
   * 배너의 "위로 모아보기"에서 사용. 서버가 moveInDateUpdateRequired desc, moveInDate asc로 정렬.
   */
  prioritizeMoveInUpdate?: boolean;

  page: number;
  size: number;
  sort: Array<string>;
};

export type GetListingResponse = {
  adminListingInfos: [
    {
      id: number;
      agencyName: string;
      thumbnailImageUrl: string;
      address: string;
      addressDetail?: string;
      nearSubwayStations: {
        subwayStation: string;
        duration: number;
      }[];
      deposit: number;
      monthlyRent: number;
      createdAt: string;
      updatedAt: string;
      isVisible: boolean;
      updatable: boolean;
      deletable: boolean;
      provisionalContractStatus: 'NONE' | 'REQUEST_RECEIVED' | 'COMPLETED';
      /** 입주가능일 ("YYYY-MM-DD"). 백엔드 반영 전에는 누락될 수 있어 옵셔널. */
      moveInDate?: string;
      /** 즉시 입주 가능 여부. true면 moveInDate는 폴백 날짜이며 "즉시 입주 가능"으로 표시. */
      isImmediateMoveIn?: boolean;
      /** 업데이트 필요 여부 = (계약 가능 && 즉시입주 아님 && 입주가능일 경과). 백엔드가 권위 있게 계산. */
      moveInDateUpdateRequired?: boolean;
    },
  ];
  /** 현재 필터 조건 전체 기준 "업데이트 필요" 매물 수 (배너 N건 / 0이면 미노출). */
  moveInDateUpdateRequiredCount?: number;
  pageInfo: {
    pageNum: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  };
};

type DeleteListingRequest = {
  id: string;
};

type PutListingRequest = {
  id?: string;
  adminId?: number;
  imageUrls: string[];
  roomType: 'STUDIO' | 'SHAREHOUSE' | 'OFFICETEL' | 'OTHERS';
  area: number;
  agentCommentTypes: Array<
    | 'COMMENT1'
    | 'COMMENT2'
    | 'COMMENT3'
    | 'COMMENT4'
    | 'COMMENT5'
    | 'COMMENT6'
    | 'COMMENT7'
    | 'COMMENT8'
    | 'COMMENT9'
    | 'COMMENT10'
    | 'COMMENT11'
  >;
  agentCommentDetailKr?: string;
  address: string;
  addressDetail?: string;
  addressEN: string;
  latitude: number;
  longitude: number;
  nearSubwayStationInfos: {
    subwayStation: string;
    duration: number;
  }[];
  nearUniversityTypes: Array<
    | 'SNU'
    | 'SSU'
    | 'CAU'
    | 'SKKU'
    | 'KOREA'
    | 'DONGGUK'
    | 'EWHA'
    | 'KHU'
    | 'HUFS'
    | 'KONKUK'
    | 'HONGIK'
    | 'YONSEI'
    | 'SOGANG'
    | 'UOS'
    | 'HANSUNG'
    | 'SEJONG'
    | 'SUNGSHIN_WOMEN'
    | 'CATHOLIC_KOREA'
    | 'METHODIST_THEOLOGICAL'
    | 'KYONGGI'
    | 'KWANGWOON'
    | 'KOOKMIN'
    | 'KOREA_CHRISTIAN'
    | 'DUKSUNG_WOMEN'
    | 'DONGDUK_WOMEN'
    | 'MYONGJI'
    | 'SAHMYOOK'
    | 'SANGMYUNG'
    | 'SEOKYEONG'
    | 'SEOUL_HANYOUNG'
    | 'SEOULTECH'
    | 'SEOUL_NATIONAL_EDUCATION'
    | 'SEOUL_CHRISTIAN'
    | 'SEOUL_WOMEN'
    | 'SUNGKONGHOE'
    | 'SOOKMYUNG_WOMEN'
    | 'PRESBYTERIAN_THEOLOGICAL'
    | 'CHONGSHIN'
    | 'CHUGYE_ARTS'
    | 'KAIST_SEOUL'
    | 'KOREAN_BIBLE'
    | 'KOREA_NATIONAL_ARTS'
    | 'KOREA_NATIONAL_SPORT'
    | 'HANSHIN'
    | 'HANYANG'
    | 'DONGYANG_MIRAE'
    | 'MYONGJI_COLLEGE'
    | 'BAEWHA_WOMEN'
    | 'SAHMYOOK_HEALTH'
    | 'SEOUL_WOMEN_NURSING'
    | 'SEOIL'
    | 'SOONGEUI_WOMEN'
    | 'INDUK'
    | 'HANYANG_WOMEN'
    | 'GACHON'
    | 'HANYANG_ERICA'
    | 'INHA'
    | 'AJOU'
    | 'KHU_GLOBAL'
    | 'SKKU_SUWON'
    | 'HUFS_GLOBAL'
    | 'CAU_ANSEONG'
    | 'CATHOLIC_KOREA_BUCHEON'
    | 'MYONGJI_YONGIN'
    | 'ANSAN'
    | 'BUCHEON'
    | 'SNU_YEONGEON'
    | 'KAIST_DAEJEON'
    | 'CNU'
    | 'HANBAT'
    | 'WOOSONG'
    | 'PAI_CHAI'
    | 'MOKWON'
    | 'DAEJEON'
    | 'EULJI_DAEJEON'
  >;
  roomFloor: number | null;
  totalFloor: number;
  isSemiBasement: boolean;
  isRooftop: boolean;
  facilityTypes: Array<'ELEVATOR' | 'CCTV' | 'ENTRY_DOORLOCK'>;
  heatingType: 'INDIVIDUAL' | 'CENTRAL';
  windowDirectionType:
    | 'NORTH'
    | 'NORTHEAST'
    | 'EAST'
    | 'SOUTHEAST'
    | 'SOUTH'
    | 'SOUTHWEST'
    | 'WEST'
    | 'NORTHWEST'
    | 'UNABLE';
  buildingFrontType: 'EXIST' | 'NOT_EXIST' | 'UNKNOWN';
  basicFurnitureTypes: Array<
    | 'GAS_STOVE'
    | 'INDUCTION'
    | 'REFRIGERATOR'
    | 'WASHING_MACHINE'
    | 'MICROWAVE_OVEN'
    | 'AIR_CONDITIONING'
    | 'DRYER'
    | 'TABLE'
    | 'TV'
    | 'WIFI'
    | 'WARDROBE'
    | 'SHELF'
    | 'DRAWER'
    | 'SHOE_RACK'
    | 'BED'
  >;
  deposit: number;
  monthlyRent: number;
  provisionalDeposit?: number;
  agencyFee: number;
  paymentType: 'MONTHLY' | 'LUMP_SUM';
  maintenanceFee: number;
  maintenanceFeeBreakdownKr?: string;
  rentExcludesTypes: Array<'ELECTRICITY' | 'WATER' | 'GAS' | 'INTERNET'>;
  /** 즉시 입주 가능(isImmediateMoveIn=true)이면 생략. 서버가 오늘 날짜로 폴백 저장. */
  moveInDate?: string;
  isImmediateMoveIn: boolean;
  minContractPeriod: number;
  adminManagerIds: number[];

  buildingUseApprovalDate: string;
  isIllegalConstruction: boolean;
  buildingRegisteredUseTypes: Array<
    | 'DETACHED_HOUSES'
    | 'MULTI_FAMILY_HOUSING'
    | 'CLASS_ONE_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'CLASS_TWO_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'OFFICETEL'
    | 'LODGING_FACILITIES'
    | 'EDUCATIONAL_AND_RESEARCH_FACILITIES'
  >;

  hasParkingLot: boolean;
  parkingLotCount?: number;

  bathroomCount: number;

  rentalType: 'MONTHLY_RENT' | 'SEMI_JEONSE' | 'JEONSE';
  isGuaranteesListing: boolean;

  hasNoAddressDetail: boolean;
};

type ChangeVisibilityRequest = {
  id: string;
};

type UserInfoResponse = {
  id: number;
  agencyType: 'ESTATE' | 'ACCOMMODATION';
  isCheckmateAdmin: boolean;
  firstName: string;
  lastName: string;
  firstNameEN: string;
  lastNameEN: string;
  email: string;
  memberRole: MemberRoleType;
};

export type getOrderRequest = {
  searchType: 'AGENCY_NAME' | 'NEAR_SUBWAY_STATION' | 'ADDRESS' | 'ORDER_NO' | 'MEMBER_NO' | 'KEYWORD';
  searchValue: string;
  page: number;
  size: number;
  sort: Array<string>;
};

export type getCompletedOrderRequest = {
  searchType: 'AGENCY_NAME' | 'NEAR_SUBWAY_STATION' | 'ADDRESS' | 'ORDER_NO' | 'MEMBER_NO' | 'KEYWORD';
  searchValue: string;
  status: 'AWAITING' | 'CONFIRMED' | 'WITHDRAWN' | 'REJECTED';
  page: number;
  size: number;
  sort: Array<string>;
};

export type GetOrderResponse = {
  contractOrderInfos: [
    {
      orderListingInfo: {
        listingId: number;
        adminId: number;
        agencyName: string;
        thumbnailImageUrl: string;
        deposit: number;
        monthlyRent: number;
        provisionalDeposit: number;
        address: string;
        addressDetail?: string;
        nearSubwayStations: [
          {
            subwayStation: string;
            duration: number;
          },
        ];
        area: number;
        roomType: 'STUDIO' | 'SHAREHOUSE' | 'OFFICETEL' | 'OTHERS';
        moveIn: string;
        /** 즉시 입주 가능 여부. true면 moveIn은 폴백 날짜이며 "즉시 입주 가능"으로 표시. */
        isImmediateMoveIn?: boolean;
        minContractPeriod: number;
        isRemittance: boolean;
        depositor: string;
        bank: string;
        account: string;
        adminManagers: AdminManagerType[];
      };
      orderContentInfos: [
        {
          orderId: number;
          memberId: number;
          firstName: string;
          lastName: string;
          genderType: 'MALE' | 'FEMALE';
          nationality: string;
          age: number;
          passportNumber: string;
          contractDate: string | null;
          memberMoveIn: string;
          memberContractPeriod: number;
          memberResidentNums: number;
          statusUpdateDate: string;
          createdAt: string;
          phoneNumber: string;
          email: string;
          // 송금정보(주문별): 재오픈으로 한 매물에 확정이 여러 건일 때 건마다 계좌·송금상태가 달라
          // listing-level이 아닌 이 주문별 값을 읽어야 각 건이 정확히 표시된다.
          isRemittance: boolean;
          depositor: string;
          bank: string;
          account: string;
          rejectReasonType:
            | 'REJECT_REASON_A'
            | 'REJECT_REASON_B'
            | 'REJECT_REASON_C'
            | 'REJECT_REASON_D'
            | 'REJECT_REASON_E'
            | 'REJECT_REASON_F'
            | 'NONE';
          rejectReason: string;
          isAdminContractDateRequest: boolean;
          priorityActivatedAt: string;
          priorityType: 'FIRST' | 'SECOND' | 'THIRD';
          crossSellItems: [
            {
              itemId: number;
              itemType: 'SERVICE' | 'MALL';
              itemName: string;
              quantity: number;
              unitPrice: number;
              totalPrice: number;
            },
          ];
        },
      ];
    },
  ];
  pageInfo: {
    pageNum: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  };
};

type RejectContractRequest = {
  orderId: number;
  listingId: number;
  rejectReasonType:
    | 'REJECT_REASON_A'
    | 'REJECT_REASON_B'
    | 'REJECT_REASON_C'
    | 'REJECT_REASON_D'
    | 'REJECT_REASON_E'
    | 'REJECT_REASON_F'
    | 'NONE';
  rejectReason: string;
};

type ApproveContractRequest = {
  orderId: number;
  listingId: number;
  contractDate: string | null;
  depositor: string;
  bank: string;
  account: string;
};

type getUserInfoResponse = {
  email: string;
  agencyType: 'ESTATE' | 'ACCOMMODATION';
  agencyName: string;
  agencyNameEN: string;
  registrationNumber: string | null;
  address: string;
  addressDetail: string;
  addressEN: string;
  agencyPhoneNumber: string;
  firstName: string;
  lastName: string;
  firstNameEN: string;
  lastNameEN: string;
  phoneNumber: string;
  languages: string[];
  mainListings: string[];
  adminManagerInfos?: AdminManagerType[];
};

type putUserInfoRequest = {
  id: string;
  email: string;
  agencyType: 'ESTATE' | 'ACCOMMODATION';
  agencyName: string;
  agencyNameEN: string;
  registrationNumber: string;
  address: string;
  addressEN: string;
  addressDetail: string;
  agencyPhoneNumber: string;
  firstName: string;
  lastName: string;
  firstNameEN: string;
  lastNameEN: string;
  phoneNumber: string;
  languages: string[];
  mainListings: string[];
  adminManagerInfos?: AdminManagersInputType[];
  memberRole: MemberRoleType;
};

type getOrderDateResponse = {
  contractOrderDates: string[];
};

type getListingDetailResponse = {
  id: string;
  adminId?: number;
  imageUrls: string[];
  roomType: 'STUDIO' | 'SHAREHOUSE' | 'OFFICETEL' | 'OTHERS';
  area: number;
  agentCommentTypes: Array<
    | 'COMMENT1'
    | 'COMMENT2'
    | 'COMMENT3'
    | 'COMMENT4'
    | 'COMMENT5'
    | 'COMMENT6'
    | 'COMMENT7'
    | 'COMMENT8'
    | 'COMMENT9'
    | 'COMMENT10'
    | 'COMMENT11'
  >;
  agentCommentDetailKr?: string;
  address: string;
  addressDetail?: string;
  addressEN: string;
  latitude: number;
  longitude: number;
  nearSubwayStationInfos: {
    subwayStation: string;
    duration: number;
  }[];
  nearUniversityTypes: Array<
    | 'SNU'
    | 'SSU'
    | 'CAU'
    | 'SKKU'
    | 'KOREA'
    | 'DONGGUK'
    | 'EWHA'
    | 'KHU'
    | 'HUFS'
    | 'KONKUK'
    | 'HONGIK'
    | 'YONSEI'
    | 'SOGANG'
    | 'UOS'
    | 'HANSUNG'
    | 'SEJONG'
    | 'SUNGSHIN_WOMEN'
    | 'CATHOLIC_KOREA'
    | 'METHODIST_THEOLOGICAL'
    | 'KYONGGI'
    | 'KWANGWOON'
    | 'KOOKMIN'
    | 'KOREA_CHRISTIAN'
    | 'DUKSUNG_WOMEN'
    | 'DONGDUK_WOMEN'
    | 'MYONGJI'
    | 'SAHMYOOK'
    | 'SANGMYUNG'
    | 'SEOKYEONG'
    | 'SEOUL_HANYOUNG'
    | 'SEOULTECH'
    | 'SEOUL_NATIONAL_EDUCATION'
    | 'SEOUL_CHRISTIAN'
    | 'SEOUL_WOMEN'
    | 'SUNGKONGHOE'
    | 'SOOKMYUNG_WOMEN'
    | 'PRESBYTERIAN_THEOLOGICAL'
    | 'CHONGSHIN'
    | 'CHUGYE_ARTS'
    | 'KAIST_SEOUL'
    | 'KOREAN_BIBLE'
    | 'KOREA_NATIONAL_ARTS'
    | 'KOREA_NATIONAL_SPORT'
    | 'HANSHIN'
    | 'HANYANG'
    | 'DONGYANG_MIRAE'
    | 'MYONGJI_COLLEGE'
    | 'BAEWHA_WOMEN'
    | 'SAHMYOOK_HEALTH'
    | 'SEOUL_WOMEN_NURSING'
    | 'SEOIL'
    | 'SOONGEUI_WOMEN'
    | 'INDUK'
    | 'HANYANG_WOMEN'
    | 'GACHON'
    | 'HANYANG_ERICA'
    | 'INHA'
    | 'AJOU'
    | 'KHU_GLOBAL'
    | 'SKKU_SUWON'
    | 'HUFS_GLOBAL'
    | 'CAU_ANSEONG'
    | 'CATHOLIC_KOREA_BUCHEON'
    | 'MYONGJI_YONGIN'
    | 'ANSAN'
    | 'BUCHEON'
    | 'SNU_YEONGEON'
    | 'KAIST_DAEJEON'
    | 'CNU'
    | 'HANBAT'
    | 'WOOSONG'
    | 'PAI_CHAI'
    | 'MOKWON'
    | 'DAEJEON'
    | 'EULJI_DAEJEON'
  >;
  roomFloor: number;
  totalFloor: number;
  isSemiBasement: boolean;
  isRooftop: boolean;
  facilityTypes: Array<'ELEVATOR' | 'CCTV' | 'ENTRY_DOORLOCK'>;
  heatingType: 'INDIVIDUAL' | 'CENTRAL';
  windowDirectionType:
    | 'NORTH'
    | 'NORTHEAST'
    | 'EAST'
    | 'SOUTHEAST'
    | 'SOUTH'
    | 'SOUTHWEST'
    | 'WEST'
    | 'NORTHWEST'
    | 'UNABLE';
  buildingFrontType: 'EXIST' | 'NOT_EXIST' | 'UNKNOWN';
  basicFurnitureTypes: Array<
    | 'GAS_STOVE'
    | 'INDUCTION'
    | 'REFRIGERATOR'
    | 'WASHING_MACHINE'
    | 'MICROWAVE_OVEN'
    | 'AIR_CONDITIONING'
    | 'DRYER'
    | 'TABLE'
    | 'TV'
    | 'WIFI'
    | 'WARDROBE'
    | 'SHELF'
    | 'DRAWER'
    | 'SHOE_RACK'
    | 'BED'
  >;
  deposit: number;
  monthlyRent: number;
  provisionalDeposit: number;
  agencyFee: number;
  paymentType: 'MONTHLY' | 'LUMP_SUM';
  maintenanceFee: number;
  rentExcludesTypes: Array<'ELECTRICITY' | 'WATER' | 'GAS' | 'INTERNET'>;
  moveInDate: string;
  /** 즉시 입주 가능 여부. 백엔드 반영 전에는 누락될 수 있어 옵셔널. */
  isImmediateMoveIn?: boolean;
  minContractPeriod: number;
  adminManagers: AdminManagerType[];
  buildingRegisteredUseTypes: Array<
    | 'DETACHED_HOUSES'
    | 'MULTI_FAMILY_HOUSING'
    | 'CLASS_ONE_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'CLASS_TWO_NEIGHBORHOOD_LIVING_FACILITIES'
    | 'OFFICETEL'
    | 'LODGING_FACILITIES'
    | 'EDUCATIONAL_AND_RESEARCH_FACILITIES'
  >;
  hasParkingLot: boolean;
  parkingLotCount?: number;
  bathroomCount: number;
  rentalType: 'MONTHLY_RENT' | 'SEMI_JEONSE' | 'JEONSE';
  isIllegalConstruction: boolean;
  isGuaranteesListing: boolean;
  hasNoAddressDetail: boolean;
  // 시군구 코드
  sigunguCode: string;
  // 가계약 상태: NONE(신청 가능) / REQUEST_RECEIVED(대기중 신청 존재, 읽기전용) / COMPLETED(완료, 재오픈 대상)
  provisionalContractStatus: 'NONE' | 'REQUEST_RECEIVED' | 'COMPLETED';
};

type ReopenListingRequest = {
  id: string;
  /** 즉시 입주 가능(isImmediateMoveIn=true)이면 생략. */
  moveInDate?: string;
  isImmediateMoveIn: boolean;
};

type ReopenListingResponse = {
  id: number;
  provisionalContractStatus: 'NONE' | 'REQUEST_RECEIVED' | 'COMPLETED';
  moveInDate: string;
  isImmediateMoveIn: boolean;
};

type UpdateMoveInDateRequest = {
  id: string;
  /** 즉시 입주 가능(isImmediateMoveIn=true)이면 생략. */
  moveInDate?: string;
  isImmediateMoveIn: boolean;
};

type UpdateMoveInDateResponse = {
  id: number;
  moveInDate: string;
  isImmediateMoveIn: boolean;
  moveInDateUpdateRequired: boolean;
};

export const admin = {
  info: (props?: { accessToken?: string }) => {
    if (props?.accessToken) {
      request.interceptors.request.use(
        (config) => {
          config.headers.Authorization = `Bearer ${props.accessToken}`;
          return config;
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    }

    return request.get<UserInfoResponse>('/admin/info');
  },
  uploadImage: (data: FormData) => request.post<string[]>('/admin/listing/image', data),
  postListing: (data: PostListingRequest) => request.post('/admin/listing', data),
  getListing: (data: getListingRequest) => {
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(key, String(v));
        });
        return;
      }
      if (value !== undefined && value !== null) searchParams.append(key, String(value));
    });

    return request.get<GetListingResponse>(`/admin/listing?${searchParams.toString()}`);
  },
  getListingDetail: ({ id }: { id: string }) => request.get<getListingDetailResponse>(`/admin/listing/${id}`),
  deleteListing: ({ id }: DeleteListingRequest) => request.delete(`/admin/listing/${id}`),
  putListing: ({ id, ...data }: PutListingRequest) => request.put(`/admin/listing/${id}`, data),
  // 가계약 완료(COMPLETED) 매물 재오픈 — 입주가능일만 변경해 다시 신청 가능(NONE) 상태로 전환
  reopenListing: ({ id, moveInDate, isImmediateMoveIn }: ReopenListingRequest) =>
    request.post<ReopenListingResponse>(`/admin/listing/${id}/reopen`, { moveInDate, isImmediateMoveIn }),
  // 계약 가능(NONE) 매물의 입주가능일만 인라인 수정 — 상태 전환 없음(reopen과 분리). NONE 외 상태는 서버가 거부.
  updateMoveInDate: ({ id, moveInDate, isImmediateMoveIn }: UpdateMoveInDateRequest) =>
    request.patch<UpdateMoveInDateResponse>(`/admin/listing/${id}/move-in-date`, { moveInDate, isImmediateMoveIn }),
  changeVisibility: ({ id }: ChangeVisibilityRequest) => request.patch(`/admin/visibility/${id}`),

  getOrder: (data: getOrderRequest) => {
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(key, String(v));
        });
        return;
      }
      if (value !== undefined && value !== null) searchParams.append(key, String(value));
    });

    return request.get<GetOrderResponse>(`/admin/order?${searchParams.toString()}`);
  },
  getCompletedOrder: (data: getCompletedOrderRequest) => {
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(key, String(v));
        });
        return;
      }
      if (value !== undefined && value !== null) searchParams.append(key, String(value));
    });

    return request.get<GetOrderResponse>(`/admin/order/completed?${searchParams.toString()}`);
  },
  rejectContract: ({ orderId, ...data }: RejectContractRequest) =>
    request.post<string>(`/admin/order/${orderId}/reject`, data),
  approveContract: ({ orderId, ...data }: ApproveContractRequest) =>
    request.post<string>(`/admin/order/${orderId}/confirm`, data),
  userInfo: ({ id }: { id: number }) => request.get<getUserInfoResponse>(`/admin/${id}`),
  putUserInfo: ({ id, ...data }: putUserInfoRequest) => request.put<string>(`/admin/${id}`, data),
  deleteUser: ({ id }: { id: number }) => request.delete<string>(`/admin/${id}`),
  getOrderDate: ({ id }: { id: number }) => request.get<getOrderDateResponse>(`/admin/order/${id}/dates`),
  getSubways: () =>
    request.get<{
      subwayStations: string[];
    }>('/admin/subway-station'),
};
